import axios from "axios";
import Cookies from "js-cookie";

axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;
axios.defaults.withCredentials = true; // si usas cookies

axios.interceptors.request.use((config) => {
  const token =
    Cookies.get("access_token") ||
    (typeof window !== "undefined" && localStorage.getItem("access_token"));

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axios; // (opcional, por si quieres importar este módulo)
